import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock } from 'lucide-react';
export function StoryHook() {
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <div className="flex items-center gap-4 mb-8 text-amber-700" data-id="element-171">
            <Clock className="w-8 h-8" data-id="element-172" />
            <span className="text-2xl font-bold tracking-wide uppercase" data-id="element-173">
              La Realidad de Cada Mañana
            </span>
          </div>

          <div className="space-y-8 text-xl md:text-2xl leading-relaxed text-stone-700 font-medium" data-id="element-174">
            <p className="first-letter:text-6xl first-letter:font-black first-letter:text-amber-600 first-letter:mr-3 first-letter:float-left" data-id="element-175">
              Son las 6:30 AM. Suena el despertador y, antes de abrir los ojos,
              ya lo sientes: ese dolor punzante en las rodillas, la espalda baja
              que parece de metal oxidado y esa rigidez que te hace caminar como
              un pingüino hacia el baño.
            </p>
            <p data-id="element-176">
              Te han dicho que es "la edad", que es "normal a los 45" y que te
              tomes un ibuprofeno. Pero tú sabes que cada mañana el dolor es un
              poco más fuerte y tu mundo se hace un poco más pequeño.
            </p>
            <p className="text-stone-600 italic" data-id="element-177">
              ¿Cuántas veces has rechazado una invitación a caminar, a jugar con
              tus hijos, o simplemente a disfrutar un domingo sin pensar en el
              dolor? Cada día que pasa sin hacer nada, tu cuerpo se oxida un
              poco más. Y lo peor: te estás acostumbrando a vivir así.
            </p>

            <div className="mt-12 p-8 bg-white border-l-4 border-amber-500 rounded-r-2xl shadow-lg" data-id="element-178">
              <p className="text-2xl md:text-3xl font-black text-stone-900 leading-tight" data-id="element-179">
                Pero no tiene que ser así.{' '}
                <span className="text-amber-600" data-id="element-180">
                  Existe una forma de despertar cada mañana sintiéndote 10 años
                  más joven.
                </span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}